<template>
    <div class="contact__conten">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="title animate__animated animate__fadeIn"><span>联系方式</span></div>
        <div class="wrapper__w text__box animate__animated animate__fadeIn" v-html="base.content"></div>
        <Footer></Footer>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/add01.png'
    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,
                base: {}
            }
        },
        components: {
            NavSecond,Footer
        },
        methods: {
            getInfo (){
                this.$xhr(this.$api.contactUs, {}).then(res => {
                    this.base = res
                })
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.getInfo()
            })
        }
    }
</script>
<style  lang="scss" scoped>
    .contact__conten{
        .title{
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            height: 200px;
            line-height: 250px;
            span{
                position: relative;
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -20px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }

        }
        .text__box{
            img{
                max-width: 100%;
            }
        }
    }

</style>
